import React, { useEffect, useState } from 'react';

import { tvSectionList, sectionCategorySorts, gnbId, DEFAULT_SECTION_CODE } from '../../../common/constants';

import Tab from '../common/Tab';
import Category from '../common/Category';

function TopMenu ({ sectionCode = DEFAULT_SECTION_CODE, categoryCode, sortCode, onChange }) {
  const defaultSection = tvSectionList.find(x => x.code === sectionCode);

  const [tvSection, setTvSection] = useState(defaultSection);
  const [currentMenu, setCurrentMenu] = useState({ categoryCode: '', sortCode: '' });
  const [pageChange, setPageChange] = useState(false);

  // 현재 URL의 마지막 경로값을 저장할 상태
  const [lastPathSegment, setLastPathSegment] = useState('');

  // `lastPathSegment` 값에 따라 iframe src 동적 변경
  const [iframeSrc, setIframeSrc] = useState('/html/pc/tv.htm');

  useEffect(() => {
    // 현재 URL에서 마지막 경로 값을 추출
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    const lastSegment = pathSegments[pathSegments.length - 1]; // 가장 마지막 값
    setLastPathSegment(lastSegment);

    // lastPathSegment 값에 따라 iframe 경로 변경
    //tv -> 전체
    //drama - > 드라마
    //enter - > 예능
    //culture - > 교양
    //sports - > 스포츠
    //free - > 무료
    switch (lastSegment) {
      case 'drama':
        setIframeSrc('/html/pc/tv_drama.htm');
        break;
      case 'enter':
        setIframeSrc('/html/pc/tv_enter.htm');
        break;
        case 'culture':
        setIframeSrc('/html/pc/tv_culture.htm');
        break;
      case 'sports':
        setIframeSrc('/html/pc/tv_sports.htm');
        break;
      case 'free':
        setIframeSrc('/html/pc/tv_free.htm');
        break;
      default:
        setIframeSrc('/html/pc/tv.htm'); // 기본값,->tv
    }
  }, []);

  function changeTvCategoryAndSort ({ sectionCode = tvSection?.code, categoryCode = '', sortCode = '' }) {
    onChange({ sectionCode, categoryCode, sortCode });
  }

  return (
    <>
      <h2 className='hide'>TV</h2>


      <div className='contents_side_ad'>
        <div className='side_ad_inner'>
          {/* lastPathSegment 값에 따라 iframe src 변경 */}
          <iframe
            title='배너광고'
            display='block'
            src={iframeSrc}
            width='120px'
            height='247px'
            scrolling='no'
            frameBorder='0'
            align='middle'
            marginWidth='0'
            marginHeight='0'
          />
        </div>
      </div>
      <div className="contents_side_ad sideAd_right">
        <div className="side_ad_inner">
          <iframe
            title='배너광고'
            display='block'
            src='/html/pc/tv_right.htm'
            width='120px'
            height='600px'
            scrolling='no'
            frameBorder='0'
            align='middle'd
            marginWidth='0'
            marginHeight='0'
          />
        </div>
      </div>

      <div className='contents_area_sorting'>
        <Category
          sectionCode={sectionCode}
          categories={tvSection?.category}
          categoryCode={categoryCode}
          sorts={sectionCategorySorts[tvSection?.sortType]?.searchParamList}
          sortCode={sortCode}
          onChange={changeTvCategoryAndSort}
          pageChange={pageChange}
        />
      </div>
    </>
  );
}

export default TopMenu;

